<template>
  <header class="header-container">
    <div class="header-content">
      <div class="logo-wrapper">
        <img 
          src="@/assets/img/Logos.png" 
          alt="France Rugby x Carte Noire" 
          class="logos-img"
        />
      </div>
      <nav>
        <router-link to="/" class="nav-link">
          Accueil
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderView",
};
</script>

<style scoped>
.header-container {
  background-color: #fff;
  padding: 15px 0;
  position: relative;
  z-index: 100;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 5vw, 60px);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-wrapper {
  position: relative;
  z-index: 100;
  margin-bottom: -60px; /* Logo overlaps into main section */
}

.logos-img {
  height: 120px;
  width: auto;
  display: block;
  object-fit: contain;
}

.nav-link {
  color: #000;
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: 20px;
  text-decoration: none;
  letter-spacing: 0.02em;
}

.nav-link:hover {
  color: #333;
}

/* Mobile */
@media (max-width: 768px) {
  .header-container {
    padding: 10px 0;
  }

  .logo-wrapper {
    margin-bottom: -40px; /* Logo overlaps into main section on mobile too */
  }

  .logos-img {
    height: 80px;
  }

  .nav-link {
    font-size: 16px;
  }
}
</style>
